import { BillFilters } from "@common/contracts/bill.contract";
import { FiltersTypes } from "@common/types/filters/general";

/**
 * Maps the filters stored on a BILLS task view (or template) onto the bills
 * list query. The task scope lives on `periodStart` / `periodEnd` (calendar
 * days of the bill date), `entityIds` and `search`; pinned membership lives on
 * `billIds`.
 */
export function toBillFilters(filters: FiltersTypes): BillFilters {
    return {
        ids: filters.billIds,
        search: filters.search,
        entityIds: filters.entityIds,
        billStatuses: filters.billStatuses,
        externalBillStatuses: filters.externalBillStatuses,
        startDate: filters.periodStart,
        endDate: filters.periodEnd,
        overdue: filters.overdue,
        minDue: filters.minDue,
        maxDue: filters.maxDue,
        minAmount: filters.minAmount,
        maxAmount: filters.maxAmount,
        accountIds: filters.accountIds,
        counterpartiesIds: filters.counterpartiesIds,
        withEmptyOrUnverifiedCounterparty:
            filters.withEmptyOrUnverifiedCounterparty,
        hasCounterparty: filters.hasCounterparty,
        matchStatuses: filters.matchStatuses,
    };
}
